<template>
<div class="chapter">
<div class="inner_page">
<p class="TOCFBM"><strong>Contents</strong></p>
<h2 class="TOCCT"><a href="#/OEBPS/c01.htm"><strong>Cake Decorating</strong></a></h2>
<p class="TOCA"><a href="#/OEBPS/c02.htm"><strong>Beautiful Birdie Biscuits</strong></a></p>
<p class="TOCA"><a href="#/OEBPS/c03.htm"><strong>Little Pot Cupcakes</strong></a></p>
<p class="TOCA"><a href="#/OEBPS/c04.htm"><strong>Superstar Cake Pops</strong></a></p>
<p class="TOCA"><a href="#/OEBPS/c05.htm"><strong>Elegant Mini Cakes</strong></a></p>
<p class="TOCA"><a href="#/OEBPS/c06.htm"><strong>Pansy Posy Cupcakes</strong></a></p>
<p class="TOCA"><a href="#/OEBPS/c07.htm"><strong>Christmas Tree Cakes</strong></a></p>
<p class="TOCA"><a href="#/OEBPS/c08.htm"><strong>Pink Daisy Cupcakes</strong></a></p>
<p class="TOCA"><a href="#/OEBPS/c09.htm"><strong>Celebration Mini Cakes</strong></a></p>
<p class="TOCA"><a href="#/OEBPS/c10.htm"><strong>Frilly Flower Cupcakes</strong></a></p>
<p class="TOCA"><a href="#/OEBPS/c11.htm"><strong>Mini Christmas Pudding Cakes</strong></a></p>
<p class="TOCA"><a href="#/OEBPS/c12.htm"><strong>Button Blossom Cupcakes</strong></a></p>
<p class="TOCFBM"><a href="#/OEBPS/c13.htm"><strong>Suppliers</strong></a></p>
<p class="TOCFBM"><a href="#/OEBPS/c14.htm"><strong>Acknowledgments</strong></a></p>
<p class="TOCFBM"><a href="#/OEBPS/c15.htm"><strong>Templates</strong></a></p>
<p class="TOCFBM"><a href="#/OEBPS/c16.htm"><strong>Get more free projects!</strong></a></p>
<p class="TOCFBM"><a href="#/OEBPS/cop.htm"><strong>Copyright</strong></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?66a38dac